/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Create_Table_Placeholder_NameInputs */



/**
* | output |
* | --- |
* | "e.g. contacts" |
*
* @param {Datasets_Create_Table_Placeholder_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_create_table_placeholder_name = /** @type {((inputs?: Datasets_Create_Table_Placeholder_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Create_Table_Placeholder_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("z. B. Kontakte")
	return /** @type {LocalizedString} */ ("e.g. contacts")
});